import React, { useState } from "react";
import "./CustomTimeSelector.css"; // Ensure you have this CSS file in the same directory
import DropIcon from "../../../assets/icons/dropdown-icon.svg";
const CustomTimeSelector = () => {
  const [hour, setHour] = useState("03");
  const [minute, setMinute] = useState("33");
  const [period, setPeriod] = useState("AM");

  // Function to increment/decrement hours and minutes
  const changeTime = (type, change) => {
    if (type === "hour") {
      let newHour = parseInt(hour) + change;
      if (newHour > 12) newHour = 1;
      if (newHour < 1) newHour = 12;
      setHour(newHour.toString().padStart(2, "0"));
    } else {
      let newMinute = parseInt(minute) + change;
      if (newMinute > 59) newMinute = 0;
      if (newMinute < 0) newMinute = 59;
      setMinute(newMinute.toString().padStart(2, "0"));
    }
  };

  return (
    <div className="custom__time-selector">
      {/* <div className="custom__time-group">
        <div className="custtime__arrow" onClick={() => changeTime("hour", 1)}>
          &#9650;
        </div>
        <div className="custom__time custom__time--selected">{hour}</div>
        <div className="custtime__arrow" onClick={() => changeTime("hour", -1)}>
          &#9660;
        </div>
      </div> */}
      <div className="custom__time_group">
        <div className="custom__time_grpleft">
          <div className="custom__time_glprev">
            {parseInt(hour) === 1 ? "12" : parseInt(hour) - 1}
          </div>
          <div className="custom__time_glcenter">{hour}</div>
          <div className="custom__time_glnext">
            {" "}
            {parseInt(hour) === 12 ? "01" : parseInt(hour) + 1}
          </div>
        </div>
        <div className="custom__time_grpright">
          <div
            className="custtime__arrow_top"
            onClick={() => changeTime("hour", -1)}
          >
            <img src={DropIcon} alt="" className="custtime__arrow_up" />
          </div>
          <div
            className="custtime__arrow"
            onClick={() => changeTime("hour", 1)}
          >
            <img src={DropIcon} alt="" className="custtime__arrow_down" />
          </div>
        </div>
      </div>
      <div className="custom__separator">:</div>
      <div className="custom__time_group">
        <div className="custom__time_grpleft">
          <div className="custom__time_glprev">
            {parseInt(minute) === 1 ? "60" : parseInt(minute) - 1}
          </div>
          <div className="custom__time_glcenter">{minute}</div>
          <div className="custom__time_glnext">
            {" "}
            {parseInt(minute) === 60 ? "01" : parseInt(minute) + 1}
          </div>
        </div>
        <div className="custom__time_grpright">
          <div
            className="custtime__arrow_top"
            onClick={() => changeTime("minute", -1)}
          >
            <img src={DropIcon} alt="" className="custtime__arrow_up" />
          </div>
          <div
            className="custtime__arrow"
            onClick={() => changeTime("minute", 1)}
          >
            <img src={DropIcon} alt="" className="custtime__arrow_down" />
          </div>
        </div>
      </div>
      <div className="custom__period-toggle">
        <div
          className={`custom__period ${
            period === "AM" ? "custom__period--selected" : ""
          }`}
          onClick={() => setPeriod("AM")}
        >
          AM
        </div>
        <div
          className={`custom__period ${
            period === "PM" ? "custom__period--selected" : ""
          }`}
          onClick={() => setPeriod("PM")}
        >
          PM
        </div>
      </div>
    </div>
  );
};

export default CustomTimeSelector;
